import { arrType, datatypes, inputTypes } from "data/globalData";

export const filterColArry = [
	{
		name: "Start Date",
		key: "start_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},
	{
		name: "End Date",
		key: "end_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},
	{
		name: "Brand",
		key: "BRAND",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				{ name: "RARE RABBIT", key: "RARE RABBIT" },
				{ name: "RAREISM", key: "RAREISM" },
				{ name: "RARE ONES", key: "RARE ONES" },
			],
		},
	},
	{
		name: "Season",
		key: "SEASON",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [{ name: "Loading...", key: "Loading" }],
		},
	},
];
